import React from "react";

import { TextField, TextFieldProps } from "@mui/material";
import { useStyles } from "./styles";
import { isNullUndefined } from "@/main/services/utils";

type TextInputProps = {
	errorMessageCustom?: string | null;
	hasOnlyNumber?: boolean;
	forceShrink?: boolean;
	onChangeCustom?: (value: string) => void;
} & TextFieldProps;

const KogInputTextUnderline = React.forwardRef(
	(
		{
			errorMessageCustom = null,
			hasOnlyNumber = false,
			forceShrink = false,
			onChangeCustom = () => {},
			...props
		}: TextInputProps,
		ref: any,
	) => {
		const styles = useStyles({});
		function handleValueChange(value: string) {
			if (hasOnlyNumber && value) {
				const onlyNumbers = value.replace(/\D/g, ""); // Remove characters that are not numbers
				return onlyNumbers;
			}
			return value;
		}
		const customInputLabelProps = forceShrink
			? {
					shrink: !isNullUndefined(props.value) && props.value != "" ? true : false,
				}
			: {};
		return (
			<TextField
				fullWidth
				size="small"
				variant="filled"
				error={errorMessageCustom !== null}
				helperText={errorMessageCustom}
				className={styles.inputTextUnderline}
				inputProps={props.inputProps ? props.inputProps : { maxLength: 100 }}
				onChange={(e) => {
					const validateValue = handleValueChange(e.target.value);
					onChangeCustom(validateValue);
				}}
				{...props}
				ref={ref}
				InputLabelProps={customInputLabelProps}
			/>
		);
	},
);

export default KogInputTextUnderline;
